import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportCreationProfilesComponent } from './component/transport-creation-profiles.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MasterDetailModule } from '@sdbn/common';

import { TableSelectionDialogModule } from '@sdbn/tmc-common';
import { ApplicationClientCommonModule } from '@sdbn/common';

import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from '../../../components/transport-options-panel/transport-options-panel.module';
import { SelectNumberPlateEntry } from './component/select-number-plates-entry/select-number-plate-entry';

import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    TableSelectionDialogModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    CommonUIModule,
    TransportOptionsPanelModule,
    MasterDetailModule,
    MatTabsModule
  ],
  declarations: [
    TransportCreationProfilesComponent,
    SelectNumberPlateEntry
  ]
})
export class TransportCreationProfilesModule { }

